import React from "react"

const StaticImage = ({ image, className, style, title, alt, forceLoad }) => {
  if (!image || image === undefined) {
    return <></>
  }
  const imageSrc = image

  return (
    <img
      loading={forceLoad ? "eager" : "lazy" }
      className={className}
      style={style}
      src={imageSrc}
      alt={alt}
      title={title ? title : alt}
    />
  )
}

export default StaticImage
